export default __webpack_public_path__ + "static/media/chevron-right-grey.659abca3.svg";